// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableLazy } from '@confluence/loadable';

export const PersistentInvitePeopleButton = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PersistentInvitePeopleButton" */ './PersistentInvitePeopleButton'
			)
		).PersistentInvitePeopleButton,
});

export { InviteButtonComponent } from './PersistentInvitePeopleButtonComponent';
